/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VoucherRedemptionLinkTarget {
  STOREFRONT = 'storefront',
  CUSTOM_URL = 'custom_url',
}
